import React from 'react';
import renderMarks from '../utils/renderMarks';
import './style.css';

var HistoryAddedComponent = function HistoryAddedComponent(_ref) {
  var children = _ref.children;
  return React.createElement("span", {
    className: "background-history-added"
  }, children);
};

var HistoryRemovedComponent = function HistoryRemovedComponent(_ref2) {
  var children = _ref2.children;
  return React.createElement("span", {
    className: "background-history-removed"
  }, children);
};

export default (function () {
  return [renderMarks({
    removed: function removed(props) {
      return React.createElement(HistoryRemovedComponent, props);
    },
    added: function added(props) {
      return React.createElement(HistoryAddedComponent, props);
    }
  })];
});